import * as React from 'react'
import type { InputDescriptionProps } from '../../../components/InputDescription'
import { useThemeStyles } from '../../../theming'
import type { InputCountProps } from '../InputCount'
import styles from './styles'

export interface BelowInputContainerProps {
  count?: React.ReactElement<InputCountProps>
  'data-.*'?: string
  'data-qa'?: string
  description?: React.ReactElement<InputDescriptionProps>
  disabled?: boolean
  error?: React.ReactElement<InputDescriptionProps>
}

export function BelowInputContainer({
  count,
  'data-qa': dataQa,
  disabled,
  description,
  error,
}: BelowInputContainerProps) {
  const maxLength = count && count.props.maxLength
  const currentLength = count && count.props.currentLength
  const hasCharacterCount = !!maxLength && !!currentLength
  const showDefaultError =
    !hasCharacterCount || (hasCharacterCount && currentLength <= maxLength)

  const sx = useThemeStyles(styles, { disabled, showDefaultError })

  return error || count || description ? (
    <div css={sx.wrap} data-qa={dataQa}>
      {showDefaultError && <div>{error}</div>}
      {description && <div>{description}</div>}
      {count && <div css={sx.count}>{count}</div>}
    </div>
  ) : null
}

BelowInputContainer.displayName = 'BelowInputContainer'
